import { render } from "./EditRequest5.vue?vue&type=template&id=49edff31"
import script from "./EditRequest5.vue?vue&type=script&lang=js"
export * from "./EditRequest5.vue?vue&type=script&lang=js"

import "./EditRequest5.vue?vue&type=style&index=0&id=49edff31&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__